module.exports = __webpack_public_path__ + "reading.537605ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/reading.jpg
// module id = Vuk+
// module chunks = 0